/**
 * @generated SignedSource<<954d2ad48bdefb5ff76c71f1d4e16113>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageEditTransportFlightsRow_data$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PackageEditTransportFlightsRowActions_data">;
  readonly " $fragmentType": "PackageEditTransportFlightsRow_data";
};
export type PackageEditTransportFlightsRow_data$key = {
  readonly " $data"?: PackageEditTransportFlightsRow_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageEditTransportFlightsRow_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageEditTransportFlightsRow_data",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageEditTransportFlightsRowActions_data"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "b1c8b648068ff4974dafb54ff238c72a";

export default node;
